/* eslint-disable react/no-danger */
import { useChoiceOptionStyles } from './ChoiceOption.styles';

type ChoiceOptionProps = {
  label: string;
  text: string;
  selected: boolean;
  disabled?: boolean;
  onSelect: () => void;
};

const ChoiceOption = ({ label, text, selected, disabled = false, onSelect }: ChoiceOptionProps) => {
  const classes = useChoiceOptionStyles();

  return (
    <button
      type="button"
      className={`${classes.choiceOption} ${selected ? classes.choiceOptionSelected : ''} ${
        disabled ? classes.choiceOptionDisabled : ''
      }`}
      disabled={disabled}
      onClick={onSelect}>
      <span className={`${classes.choiceRadio} ${selected ? classes.choiceRadioSelected : ''}`} />
      <span className={`${classes.choiceOptionLabel} ${selected ? classes.choiceOptionLabelSelected : ''}`}>
        {label}
      </span>
      <span
        className={classes.choiceOptionText}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </button>
  );
};

export default ChoiceOption;
